import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    useDataProvider,
    DataProviderContext,
    FunctionField,
} from 'react-admin';
import React, { useMemo, useState } from "react";
import MonthSelector from '../../../common/MonthSelector';
import FormattedDateTimeField from "../../../common/FormattedDateTimeField";
import { NoDataSection } from "../../../common/NoDataSection";
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import { goApi, createCustomGoDataProvider } from '../../../services';
const ReportUserSignupsList = () => {
    const [selectedMonthRange, setSelectedMonthRange] = useState<any>(null);
    const baseDataProvider = useDataProvider();
    const listFilter = useMemo(() => {
        if (!selectedMonthRange) return {};
        return { monthYear: selectedMonthRange.month };
    }, [selectedMonthRange]);

    const customDataProvider = useMemo(() => {
        const dp = createCustomGoDataProvider(baseDataProvider, [
            {
                resource: 'report_user_signups',
                apiEndpoint: '/users/reports',
            },
        ]);

        dp.downloadUsersReport = async (filters: any = {}) => {
            const query = new URLSearchParams(filters).toString();
            const response = await goApi.get(`/users/reports/download?${query}`);
            return response.data; 
        };

        return dp;
    }, [baseDataProvider]);

    const handleDownload = async () => {
        try {
            const response = await customDataProvider.downloadUsersReport(listFilter);

            const fileUrl = response?.url || response?.data?.url;
            if (fileUrl) {
                window.open(fileUrl, '_blank', 'noopener,noreferrer');
            } else {
                console.error("Download URL missing");
            }
        } catch (error) {
            console.error("Download failed", error);
        }
    };

    const CustomActions = () => (
        <TopToolbar>
            <MonthSelector
                monthsToShow={12}
                setSelectedMonthRange={setSelectedMonthRange}
                selectedMonthRange={selectedMonthRange}
            />
            <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
            >
                Export
            </Button>
        </TopToolbar>
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <List
                actions={<CustomActions />}
                perPage={50}
                sort={{ field: 'createdAt', order: 'DESC' }}
                resource="report_user_signups"
                filter={listFilter}
                empty={<NoDataSection resource="report_user_signups" />}
            >
                <Datagrid bulkActionButtons={false}>
                    <FunctionField
                        label="Full Name"
                        render={(record: any) =>
                            `${record.firstName || ''} ${record.lastName || ''}`.trim()
                        }
                    />
                    <TextField source="city" />
                    <TextField source="className" label="Class" />
                    <TextField source="email" />
                    <TextField source="phone" />
                    <TextField source="status" />
                    <FormattedDateTimeField source="createdAt" />
                </Datagrid>
            </List>
        </DataProviderContext.Provider>
    );
};
export default ReportUserSignupsList;